import React, { useState } from "react";
import "./App.css";

// ================= COMPONENTS =================
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrendingNow from "./components/TrendingNow";
import Categories from "./components/Categories";
import ProductGrid from "./components/ProductGrid";
import ProductDetails from "./components/ProductDetails";
import About from "./components/About";
import Toast from "./components/Toast";
import MiniCartDrawer from "./components/MiniCartDrawer";
import SearchBar from "./components/SearchBar";

// ================= CONTEXT =================
import { useCart } from "./context/CartContext";

// ================= ROUTER =================
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// ================= PAGES =================
import CartPage from "./pages/CartPage";
import AddressPage from "./pages/AddressPage";
import PaymentPage from "./pages/PaymentPage";
import OrderSuccess from "./pages/OrderSuccess";
import Login from "./pages/Login";
import Register from "./pages/Register";
import WishlistPage from "./pages/WishlistPage";
import ProfilePage from "./pages/ProfilePage";

// ================= AUTH GUARD =================
import RequireAuth from "./utils/RequireAuth";

function App() {
  const { toast, setShowCart } = useCart();

  return (
    <Router>
      <div className="min-h-screen text-[#5B2E3C] bg-[#FFF6FA]">
        {/* ================= NAVBAR ================= */}
        <Navbar onCartOpen={() => setShowCart(true)} />

        <main>
          <Routes>
            {/* ================= HOME ================= */}
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <TrendingNow />

                  <section
                    id="products"
                    className="max-w-6xl mx-auto px-4 py-12"
                  >
                    <div className="rounded-2xl bg-white/60 p-6 md:p-8 shadow-sm border border-[#FADCE7]">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                        <h2 className="text-2xl font-semibold">New In</h2>
                        <p className="mt-2 md:mt-0 text-sm text-gray-600">
                          Small-batch pieces, handcrafted with care.
                        </p>
                      </div>

                      <div className="mt-6">
                        <ShopArea />
                      </div>
                    </div>
                  </section>

                  <About />
                </>
              }
            />

            {/* ================= PRODUCT DETAILS ================= */}
            <Route path="/product/:slug" element={<ProductDetails />} />

            {/* ================= CART ================= */}
            <Route path="/cart" element={<CartPage />} />

            {/* ================= AUTH ================= */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* ================= PROTECTED ================= */}
            <Route
              path="/wishlist"
              element={
                <RequireAuth>
                  <WishlistPage />
                </RequireAuth>
              }
            />

            <Route
              path="/profile"
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />

            <Route
              path="/address"
              element={
                <RequireAuth>
                  <AddressPage />
                </RequireAuth>
              }
            />

            <Route
              path="/payment"
              element={
                <RequireAuth>
                  <PaymentPage />
                </RequireAuth>
              }
            />

            <Route
              path="/success"
              element={
                <RequireAuth>
                  <OrderSuccess />
                </RequireAuth>
              }
            />
          </Routes>

          {/* ================= TOAST ================= */}
          <Toast message="Added to cart!" show={toast} />

          {/* ================= MINI CART ================= */}
          <MiniCartDrawer />
        </main>
      </div>
    </Router>
  );
}

// ================= SHOP AREA =================
function ShopArea() {
  const [selected, setSelected] = useState("All");
  const [search, setSearch] = useState("");

  return (
    <>
      <SearchBar value={search} onChange={setSearch} />
      <Categories selected={selected} onSelect={setSelected} />
      <ProductGrid filter={selected} search={search} />
    </>
  );
}

export default App;
